import { ChangeEvent, useState } from "react";

import { hasValue, styles } from "@repo/helpers";

import { InputComponent } from "../input";
import style from "./style.module.scss";
import { BaseProps } from "./types";

export function Checkbox(props: BaseProps) {
	const { title, large = true, ...inputProps } = props;
	const { id, name, value, disabled, label, changeHandler } = inputProps;
	const [focused, setFocused] = useState(false);

	const updateFocused = () => setFocused(!focused);

	function onChange(event: ChangeEvent<HTMLInputElement>) {
		if (disabled) return;
		if (changeHandler) {
			changeHandler(event.target.checked, id);
		}
	}

	return (
		<InputComponent
			{...inputProps}
			hideLabel={!hasValue(title)}
			label={title}
			onFocused={updateFocused}
			onUnfocused={updateFocused}
		>
			{
				<label className={style.checkboxLabel}>
					<input
						id={id || name}
						name={name || id}
						type="checkbox"
						className={styles(style.checkbox, large && style.checkboxLarge, "form-check-input")}
						checked={!!value || false}
						disabled={disabled}
						onChange={onChange}
					/>
					{label}
				</label>
			}
		</InputComponent>
	);
}
